import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { AppState } from 'services/types';
import { SpraySubmissionId } from 'services/spraySubmissions/types';

interface SelectSpraySubmissionIdProps {
    spraySubmissionId: SpraySubmissionId;
}

const selectSpraySubmissionId = (
    state: AppState,
    props: SelectSpraySubmissionIdProps
): SpraySubmissionId => props.spraySubmissionId;

const selectLoadSpraySubmissionParams = createDeepEqualSelector(
    selectSpraySubmissionId,
    selectCurrentOrganizationId,
    (spraySubmissionId, organizationId) => ({
        organizationId,
        filter: {
            fields: [
                'id',
                'sprayEventProductId',
                'sprayExportId',
                'submittedAt',
                'succeededAt',
                'failedAt',
                'sprayProductId',
                'errorMessage',
                'eventId',
                'payload',
                'sprayEventProduct.id',
                'sprayEventProduct.sprayEvent.id',
                'sprayEventProduct.sprayEvent.sprayEntities.id'
            ],
            eager: 'sprayEventProduct.sprayEvent.sprayEntities',
            where: {
                recency: 1,
                sprayExportId: spraySubmissionId
            }
        }
    })
);

export { selectLoadSpraySubmissionParams };
